import React from "react"
import ReactMarkdown from "react-markdown"
import Breadcrumbs from "@components/global/Breadcrumbs/Breadcrumbs"
import Button from "@components/objects/Button/Button"
import SiteWrapper from "@components/structure/SiteWrapper/SiteWrapper"
import ProductList from "../ProductList/ProductList"
import * as styles from "./ProductEdit.module.scss"

const ProductEdit = ({ title, description, featuredImage, products, formatTitle }) => {
  const firstWord = title.split(" ")[0]
  const restOfTitle = title.substring(title.indexOf(" "))

  return (
    <section className={styles.ProductEdit}>
      <SiteWrapper className={styles.wrapper}>
        <Breadcrumbs color="dark" elements={[["The Shop", "/products"], title]} />
        <div className={styles.intro}>
          <div className={styles.text}>
            {formatTitle ? (
              <h1>
                <span>{firstWord}</span>
                {restOfTitle}
              </h1>
            ) : (
              <h1>{title}</h1>
            )}
            <ReactMarkdown>{description}</ReactMarkdown>
          </div>
        </div>
        <ProductList products={products} hasMore={false} />
        <Button
          className={styles.backBtn}
          text="Back to Shop"
          design="outline"
          color="pink"
          link="/products"
        />
      </SiteWrapper>
    </section>
  )
}

export default ProductEdit
